import type { GetFeaturesInnerParams } from '@/app/components/search/components/EvolutionCard/Details/Features/getFeatures/types.ts';
import { getBaggage } from '@/app/components/search/components/EvolutionCard/utils/featureUtils.ts';
import { type Feature } from '@/app/components/search/components/EvolutionCard/utils/facilitiesTypes.ts';

export const getBaggageFeatures = ({
  isDP,
  isHO,
  isOpx,
  dealCard,
  isOverlay,
  t,
  isMobile,
  isLiveSearch,
  localization,
  adultsChildrenCount,
  transportData,
}: GetFeaturesInnerParams): Feature[] => {
  if (isHO || !dealCard) return [];

  const bags = getBaggage({
    dealCard,
    transportData,
    t,
    localization,
    showFallback: false,
    adultsChildrenCount,
    isMobile,
    isOpx,
  });

  return [...(isLiveSearch && bags && isDP && !isOverlay ? [bags] : [])];
};
